import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Container, Alert, Spinner } from 'react-bootstrap';
import { ApiManager } from '../../../core/api-manager';
import { LoginManager } from '../../../core/login-manager';
import { LanguageProvider } from '../../../core/language-provider';



export default function AutoLogin() {

    const navigate = useNavigate();

    const [errors, setErrors] = useState('');
    const [data, setData] = useState(1);

    const [searchParams, setSearchParams] = useSearchParams();
    const [token, setToken] = useState(searchParams.get("token") || null);



    async function init() {
        console.log(searchParams, token);
        const r1 = await ApiManager.sendRequest('/public/autologin?token=' + token, {});
        console.log("login", r1);
        if (r1.success === 1) {
            const response = await login(r1.body.username, r1.body.password, 1);
        }
    }

    useEffect(() => {
        init()
    }, []);


    async function login(username, password, rememberme) {
        let body = {
            rememberme: rememberme,
            password: password,
            username: username
        }
        let response = await ApiManager.sendRequest('/auth/login', body)
        if (response.success === 1) {
            LoginManager.afterLoginActions(response)
            navigate('/');
        }
        return response;
    }





    if (data !== null) {

        return (
            <>
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="primary" />
                    <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                </div>

            </>
        )
    }
    else {
        return (
            <>

            </>

        )
    }
};